<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{'--width': widthVar}"  class="pageHeader">设备交接日志</h3>
    <div>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="我创建的" name="first">
          <SkTabMine ref="mine" />
        </el-tab-pane>
        <el-tab-pane label="课后交接" name="second">
          <SkTabConfirm ref="confirm" />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
// import { mixinList } from '@/assets/js/mixin/list';
import SkTabMine from './components/skTabMine';
import SkTabConfirm from './components/skTabConfirm';

export default {
  name: 'JournalOfEqSX',
  data() {
    return {
      activeName: 'first',
    };
  },
  created() {},
  components: {
    SkTabMine,
    SkTabConfirm,
  },
  mounted() {
    this.handleClick({ name: this.activeName });

    // this.getList();
  },
  methods: {
    handleClick(tab, event) {
      switch (tab.name) {
        case 'first':
          this.$refs.mine.getList();
          break;
        case 'second':
          this.$refs.confirm.getList();
          break;
        default:
          this.$refs.mine.getList();
          break;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}
</style>
